import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon } from '@shared/ui';

import cls from './AddButton.module.css';

interface AddButtonProps {
    classes?: string;
    isShowLabel?: boolean;
    onClick?: () => void;
}

export const AddButton = ({
    classes,
    isShowLabel = false,

    ...restProps
}: AddButtonProps) => {
    const { t } = useTranslation();
    return (
        <button
            className={cn(cls.AddButton, isShowLabel && cls.AddButtonWithLabel, classes)}
            {...restProps}
        >
            <Icon iconName="plus" />
            <span className={cls.AddButtonLabel}>{t('button.add.text')}</span>
        </button>
    );
};
